<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    "
  >
    <div>
      <div class="px-4">
        <v-row>
          <v-col cols="4">
            <combobox-municipio
              multiple
              :clearable="true"
              :value="filtros.municipioId"
              @onChange="(e) => changeMunicipio(e)"
              @nameChange="(e) => (nomes.municipio = e)"
              :filterByStatusAndProject="filteres"
            ></combobox-municipio>
          </v-col>
          <v-col cols="3">
            <datepicker
              :label="'Data do T0'"
              @onChange="(e) => addFiltros('dataInicial', e)"
              :value="filtros.dataInicial"
            >
            </datepicker>
          </v-col>
          <v-col cols="3">
            <datepicker
              :label="'Data do T1'"
              @onChange="(e) => addFiltros('dataFim', e)"
              :value="filtros.dataFim"
            ></datepicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <app-status-relacionamento
              :filter="filtros"
              :isMultiple="true"
              :disabled="filtros.municipioId.length > 0"
            ></app-status-relacionamento>
          </v-col>
          <v-col>
            <combobox-projeto
              :filter="filtros"
              @nameChange="(e) => (nomes.projeto = e)"
              @changeProject="(e) => addFiltros('projetoId', e)"
              :disabled="filtros.municipioId.length > 0"
            ></combobox-projeto>
          </v-col>
        </v-row>

        <v-row class="justify-end px-4">
          <v-btn color="success" class="buttonc mr-1" @click="gerarPDF">
            <v-icon dark>mdi-download</v-icon>Gerar PDF
          </v-btn>
          <v-btn color="primary" @click="filtrar"> Gerar Relatório</v-btn>
        </v-row>
      </div>
    </div>
    <div style="margin-top: 1rem">
      <v-row
        v-for="(item, index) in dataValues"
        :key="index"
        :style="{
          maxHeight: item.length == 1 ? '320px' : 'none',
        }"
      >
        <v-col lg="6" md="6" sm="12" class="mt-5">
          <div class="title-radar">{{ item[0].municipio }}</div>
          <v-data-table
            :headers="headers"
            :items="item"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-col>
        <v-col lg="6" md="6" sm="12" class="vamospdf">
          <radar-chart
            :chart-data="fillChart(item)"
            :options="getLineChartOptions(item)"
            :width="200"
            :height="200"
          ></radar-chart>
        </v-col>
      </v-row>
      <div class="noFilters" v-if="mensagemFiltro">{{ mensagemFiltro }}</div>
    </div>
  </div>
</template>
<script>
import RadarChart from "@/components/chart/RadarChart.vue";
import { cityAPI } from "@/modules/city/API/CityAPI";
import { mapActions, mapGetters } from "vuex";
import { atualUfDefinition } from "@/helpers/utils";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { convertImgToBase64 } from "@/helpers/convertImgToBase64";
import moment from "moment";
import ComboboxMunicipio from "@/modules/city/components/ComboboxMunicipio.vue";
import Datepicker from "@/components/datepicker/datepicker.vue";
import AppStatusRelacionamento from "@/modules/city/components/ComboboxStatusRelacionamento";
import ComboboxProjeto from "@/modules/project/components/Combobox";

export default {
  components: {
    RadarChart,
    ComboboxMunicipio,
    Datepicker,
    AppStatusRelacionamento,
    ComboboxProjeto,
  },

  watch: {
    filtros: {
      handler(val) {
        this.filteres.statusId =
          (val.statusId &&
            val.statusId.length &&
            val.statusId.map((item) => item.statusId)) ||
          [];
        this.filteres.projetoId = val.projetoId;
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  data() {
    return {
      dataValues: [],
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      config: JSON.parse(localStorage.getItem("config")),
      mensagemFiltro: "Os filtros são obrigatórios para a exibição.",
      filtros: { municipioId: [] },
      filteres: { statusId: [], projetoId: [] },
      nomes: { municipio: [] },
      gapRadar: null,
      old: [],
      erros:
        "Projeto é obrigatório <br>Status é obrigatório <br>T0 é obrigatório <br>T1 é obrigatório <br>",
      headers: [
        { text: "Eixo", value: "tema", sortable: false },
        { text: "T0", value: "to", sortable: false },

        { text: "T1", value: "t1", sortable: false },
        //  { text: "T2", value: "t2", sortable: false },

        { text: "Evolução", value: "evolucao", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isSala", "logos"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    changeMunicipio(e) {
      if (e.length > 0) {
        this.filtros.projetoId = null;
        this.filtros.statusId = [];
      }
      this.addFiltros("municipioId", e);
    },
    addFiltros(name, val) {
      this.filtros[name] = val;
      this.$forceUpdate();
    },
    fillChart(value) {
      let dataset = [];
      let tema = [];
      tema = value.map((item) => {
        if (
          item.tema &&
          !Array.isArray(item.tema) &&
          item.tema.split(" ").length > 3
        ) {
          item.tema = item.tema.match(/\b[\w']+(?:[^\w\n]+[\w']+){0,2}\b/g);
        }

        return item.tema;
      });
      dataset = [
        // {
        //   label: "T2",
        //   backgroundColor: "rgba(00, 255, 255, 0.1)",
        //   borderColor: "#eead2d",
        //   borderWidth: 3,
        //   data: value.map((item) => item.t2.replace("%", "")),
        // },
        {
          label: "T1",
          backgroundColor: "rgba(00, 255, 255, 0.1)",
          borderColor: "#120a8f",
          borderWidth: 3,
          data: value.map((item) => item.t1),
        },
        {
          label: "T0",
          backgroundColor: "rgba(00, 255, 00, 0.1)",
          borderColor: "#00FF00",
          borderWidth: 3,
          data: value.map((item) => item.to),
        },
      ];

      return {
        labels: tema,
        datasets: dataset,
      };
    },
    getLineChartOptions(value) {
      const municipio = value.map((item) => item.municipio)[0];
      return {
        responsive: true,
        title: {
          display: true,
          fontColor: atualUfDefinition.corPrimaria,

          fontSize: 14,
          text: municipio,
        },
        legend: {
          display: true,
          reverse: true,
          labels: {
            usePointStyle: true,
            pointStyle: "circle",
          },
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItem, chart) => {
              const realValue =
                chart.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ];
              const customValue = realValue;
              const label = chart.labels[tooltipItem.index] + ":";
              return label + customValue;
            },
          },
        },

        responsive: true,

        scale: {
          max: 100,
          min: 0,

          gridLines: {
            color: "#bababa",
          },
          grid: {
            color: "#bababa",
          },
          angleLines: {
            color: "#bababa",
          },
          pointLabels: {
            fontColor: "#000",
            fontSize: 10,
          },

          ticks: {
            fontColor: "#000",
            min: 0,
            beginAtZero: true,
            max: 100,
            stepSize: 20,
            callback: function (value, index, ticks) {
              return value;
            },
          },
        },
        defaultColor: "rgba(00, 255, 00, 0.1)",
      };
    },
    filtroRelatorio(doc) {
      doc.setFontSize(12).setFont(undefined, "bold");
      doc.text(40, 80, "Filtros selecionados:");

      const header = ["Municípios", "T0", "T1", "Status", "Projeto"];

      let rows = [];

      rows.push([
        (this.nomes.municipio && this.nomes.municipio.join(", ")) || "",
        moment(this.filtros.dataInicial, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY"
        ),
        moment(this.filtros.dataFim, "YYYY-MM-DD  HH:mm:ss").format(
          "DD/MM/YYYY"
        ),
        (this.filtros.statusId &&
          this.filtros.statusId.length &&
          this.filtros.statusId.map((val) => val.statusNome).join(",")) ||
          "",
        this.nomes.projeto,
      ]);

      doc.autoTable(header, rows, {
        startY: 90,
        styles: { overflow: "linebreak", cellWidth: "wrap" },
        showHead: "everyPage",
        columnStyles: {
          0: { cellWidth: 100 },
          1: { cellWidth: 100 },
          2: { cellWidth: 100 },
          3: { cellWidth: 100 },
          4: { cellWidth: 100 },
          // etc
        },
      });

      return doc;
    },
    async gerarPDF() {
      if (this.erros) {
        this.$notification.error(this.erros, { messageIsHTML: true });
        return;
      }

      this.setLoading(true);
      try {
        const header = ["Eixo", "T0", "T1", "Evolução"];
        var doc = new JsPDF("p", "pt");

        var titulo = "Relatório Administrativo - Radar";
        var logoCidade = new Image();

        var dimensions = {
          width: 0,
          height: 30,
        };

        if (this.isSala) {
          logoCidade.src = await convertImgToBase64(
            `https://slide1-images.s3.amazonaws.com/public/logo/logo-selo.png`,
            400,
            500
          );

          dimensions = {
            width: 70,
            height: 70,
          };
        } else {
          logoCidade.src = await convertImgToBase64(this.logos.logo);
        }

        var logoSebrae = new Image();
        logoSebrae.src = await convertImgToBase64(
          "https://slide1-images.s3.amazonaws.com/public/sebrae-logo.png"
        );

        doc.addImage(logoSebrae, "PNG", 500, 30, 50, 20);

        if (
          this.isFullAdmin ||
          (this.groupsConfig.visualizarLogo && this.config.visualizarLogo)
        ) {
          doc.addImage(
            logoCidade,
            "PNG",
            30,
            20,
            dimensions.width,
            dimensions.height
          );
        }

        doc.setFontSize(16).setFont(undefined, "bold");
        doc.text(180, 45, titulo);

        doc = this.filtroRelatorio(doc);

        for (let i = 0; i < this.dataValues.length; i++) {
          let startNewY = 100;
          let rows = [];

          let valorEntreEles = (this.dataValues[i].length + 1) * 21.5;
          let gap = 50;

          if (this.old && this.old.length <= 2 && i > 0) {
            gap = 140;
          } else if (valorEntreEles < 200) {
            gap = 100;
          }

          if (
            doc.lastAutoTable.finalY + valorEntreEles + startNewY - 10 + gap >
            doc.internal.pageSize.getHeight()
          ) {
            doc.addPage();
            doc.lastAutoTable.finalY = null;

            doc.addImage(logoSebrae, "PNG", 500, 30, 50, 20);

            if (
              this.isFullAdmin ||
              (this.groupsConfig.visualizarLogo && this.config.visualizarLogo)
            ) {
              doc.addImage(
                logoCidade,
                "PNG",
                30,
                20,
                dimensions.width,
                dimensions.height
              );
            }

            doc.text(180, 45, titulo);
          }

          if (doc.lastAutoTable.finalY) {
            startNewY = doc.lastAutoTable.finalY + gap;
          }

          doc.text(
            (this.dataValues[i] &&
              this.dataValues[i].length &&
              this.dataValues[i][0].municipio) ||
              "",
            40,
            startNewY - 10
          );

          var canvas = document.querySelectorAll(".vamospdf canvas");
          var canvasImg = canvas[i].toDataURL("image/png", 1.0);

          for (let j = 0; j < this.dataValues[i].length; j++) {
            rows.push([
              this.dataValues[i][j].tema,
              this.dataValues[i][j].to,
              this.dataValues[i][j].t1,
              // this.dataValues[i][j].t2,
              this.dataValues[i][j].evolucao,
            ]);
          }

          doc.addImage(
            canvasImg,
            "JPEG",
            doc.internal.pageSize.getWidth() / 2 + 50,

            startNewY - 10,
            200,
            200
          );

          doc.autoTable(header, rows, {
            startY: startNewY,
            tableWidth: doc.internal.pageSize.getWidth() / 2,
            styles: { overflow: "linebreak", cellWidth: "wrap" },
          });
          this.old = this.dataValues[i];
        }

        doc.save(
          `Relatório Radar - ${moment().format("DD_MM_YYYY_HH_mm")}.pdf`
        );
        this.setLoading(false);
      } catch (error) {
        console.log("error: ", error);
        this.$notification.error("Alguma coisa deu errado");
        this.setLoading(false);
      }
    },
    groupValues(itens) {
      let key = "municipio";
      return itens.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    filtrar() {
      console.log("🚀 ~ filtrar ~ this.filtros.:", this.filtros);

      this.erros = "";
      if (!this.filtros.municipioId.length && !this.filtros.projetoId) {
        this.erros += "Projeto é obrigatório <br>";
      }

      if (
        !this.filtros.municipioId.length &&
        (!this.filtros.statusId || this.filtros.statusId.length == 0)
      ) {
        this.erros += "Status é obrigatório <br>";
      }
      if (!this.filtros.dataInicial) {
        this.erros += "Data do T0 é obrigatório <br>";
      }
      if (!this.filtros.dataFim) {
        this.erros += "Data do T1 é obrigatório <br>";
      }

      if (
        moment(this.filtros.dataInicial, "YYYY-MM-DD").isAfter(
          moment(this.filtros.dataFim, "YYYY-MM-DD")
        )
      ) {
        this.erros += "Data do T1 menor que data do T0";
      }

      if (this.erros) {
        this.$notification.error(this.erros, { messageIsHTML: true });
        return;
      }

      var filtros = {
        dataTO: this.filtros.dataInicial + " 23:59:00",
        dataT1: this.filtros.dataFim + " 23:59:00",
        municipio: this.filtros.municipioId.length
          ? this.filtros.municipioId.join(",")
          : null,
        projetos:
          (this.filtros.projetoId && this.filtros.projetoId + "") || null,
        status:
          (this.filtros.statusId &&
            this.filtros.statusId.length &&
            this.filtros.statusId.map((val) => val.statusId).join(",")) ||
          null,
      };

      this.load(filtros);
    },
    load(fill) {
      this.setLoading(true);
      this.dataValues = [];
      cityAPI.getRadar(fill).then((item) => {
        if (item.data.length > 0) {
          this.mensagemFiltro = "";
          let maximoValor = item.data.sort(function (a, b) {
            return b.maximoTema - a.maximoTema;
          })[0].maximoTema;

          let minValor = item.data.sort(function (a, b) {
            return a.maximoTema - b.maximoTema;
          })[0].maximoTema;

          let gap = Math.floor((maximoValor / 5) * 100) / 100;
          this.gapRadar = { max: maximoValor, gap: gap, min: minValor };
          this.dataValues = Object.values(this.groupValues(item.data)).map(
            (item) => {
              return item.map((val) => {
                return {
                  evolucao: val.evolucao,
                  municipio: val.municipio,
                  municipioId: val.municipioId,
                  t1: val.t1,
                  //  t2: val.t2 + "%",
                  to: val.to,
                  tema: val.tema,
                };
              });
            }
          );
        } else {
          this.mensagemFiltro = "Nenhum dado encontrado";
        }

        this.setLoading(false);
      });
    },
  },

  mounted() {
    this.setLoading(false);
  },
};
</script>
<style scoped>
.title-radar {
  text-align: center;
  color: white;
  background: var(--corPrimaria);
}
.noFilters {
  background: #00000008;
  justify-content: center;
  display: flex;
  color: #000000ad;
  padding: 20px;
  border-radius: 10px;
}
</style>
